import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import type { AccessState } from '@/hooks/useMembershipStatus';
import { useLanguage } from '@/i18n/LanguageContext';

interface AccessGateModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  accessState: AccessState;
}

const AccessGateModal = ({ open, onOpenChange, accessState }: AccessGateModalProps) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const modalContent: Record<string, { title: string; message: string; buttonText: string; navigateTo?: string }> = {
    guest: { title: t('gate.membersOnly'), message: t('gate.signUpOrLogin'), buttonText: t('gate.goToLogin'), navigateTo: '/auth' },
    pending: { title: t('gate.underReview'), message: t('gate.pendingApproval'), buttonText: t('gate.ok') },
    blocked: { title: t('gate.restricted'), message: t('gate.cannotAccess'), buttonText: t('gate.ok') },
    trial_ended: { title: t('gate.trialEnded'), message: t('gate.trialEndedMessageV2'), buttonText: t('gate.upgradeNow'), navigateTo: '/subscribe' },
  };

  const content = modalContent[accessState];
  if (!content) return null;

  const handleAction = () => {
    onOpenChange(false);
    if (content.navigateTo) navigate(content.navigateTo);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{content.title}</DialogTitle>
          <DialogDescription>{content.message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleAction}>{content.buttonText}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AccessGateModal;
